module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10265.a32553e0.jpg";